import React from 'react';
import { Button } from './ui/Button';
import { Sparkles, MessageCircle, Activity, Battery, Utensils } from 'lucide-react';
export function MethodSection() {
  const results = [{
    icon: <Sparkles className="w-6 h-6 text-emerald-600" data-id="element-203" />,
    result: 'Baja la hinchazón',
    meaning: 'Te despertás liviana. Podés ponerte lo que querés.'
  }, {
    icon: <Utensils className="w-6 h-6 text-emerald-600" data-id="element-204" />,
    result: 'Reduce antojos',
    meaning: 'Dejás de luchar con el dulce. Comé sano sin sufrirlo.'
  }, {
    icon: <Activity className="w-6 h-6 text-emerald-600" data-id="element-205" />,
    result: 'Ordena tu digestión',
    meaning: 'Tu cuerpo funciona. Predecible. Sin sorpresas.'
  }, {
    icon: <Battery className="w-6 h-6 text-emerald-600" data-id="element-206" />,
    result: 'Recupera tu energía',
    meaning: 'Llegás a la tarde sin caer rendida.'
  }, {
    icon: <MessageCircle className="w-6 h-6 text-emerald-600" data-id="element-207" />,
    result: 'Te dice exactamente qué comer',
    meaning: 'Sin adivinar. Sin improvisar. Sin angustia.'
  }];
  return <section className="py-20 bg-white relative" data-id="element-208">
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-emerald-400 to-emerald-600" data-id="element-209"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <div className="max-w-5xl mx-auto" data-id="element-211">
          <div className="text-center mb-16" data-id="element-212">
            <span className="text-emerald-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-213">
              La Solución Definitiva
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-214">
              Por eso existe el <br className="hidden md:block" data-id="element-215" />
              <span className="text-emerald-600" data-id="element-216">
                Método 28 Días sin Inflamación 🌿
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-217">
              El plan paso a paso que ordena tu digestión, elimina la hinchazón
              y te enseña a comer sin culpa — en 28 días concretos.
            </p>
          </div>

          <div className="bg-stone-50 rounded-3xl p-8 md:p-12 shadow-sm border border-stone-100 mb-12" data-id="element-218">
            <div className="grid gap-8" data-id="element-219">
              {results.map((item, idx) => <div key={idx} className="flex flex-col md:flex-row md:items-center gap-4 border-b border-stone-200 pb-6 last:border-0 last:pb-0" data-id="element-220">
                  <div className="flex items-center gap-4 md:w-1/3" data-id="element-221">
                    <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-222">
                      {item.icon}
                    </div>
                    <h3 className="font-bold text-lg text-gray-900" data-id="element-223">
                      {item.result}
                    </h3>
                  </div>
                  <div className="hidden md:block text-stone-300" data-id="element-224">→</div>
                  <div className="md:w-2/3" data-id="element-225">
                    <p className="text-gray-600 italic text-lg" data-id="element-226">
                      "{item.meaning}"
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="text-center space-y-8" data-id="element-227">
            <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-12 text-lg font-bold text-gray-800" data-id="element-228">
              <span className="flex items-center justify-center gap-2" data-id="element-229">
                <span className="w-2 h-2 bg-emerald-500 rounded-full" data-id="element-230"></span>
                Sin contar calorías
              </span>
              <span className="flex items-center justify-center gap-2" data-id="element-231">
                <span className="w-2 h-2 bg-emerald-500 rounded-full" data-id="element-232"></span>
                Sin eliminar todo lo que te gusta
              </span>
              <span className="flex items-center justify-center gap-2" data-id="element-233">
                <span className="w-2 h-2 bg-emerald-500 rounded-full" data-id="element-234"></span>
                Sin vivir a dieta el resto de tu vida
              </span>
            </div>

            <a href="https://www.elplacerquenutre.com//cart/44835922083942:1" data-id="element-235">
              <Button size="xl" withArrow className="w-full md:w-auto px-12" data-id="element-236">
                QUIERO HACER EL RETO
              </Button>
            </a>
            <div data-id="element-237">
              <p className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-238">
                $14,997 con el 50% desc
              </p>
              <p className="text-sm font-medium text-gray-500" data-id="element-239">
                Pago único — sin suscripciones
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}